import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextStrikethrough"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 11.25H13.467C13.134 11.1604 12.7994 11.0767 12.4635 10.9987C10.3575 10.5007 9.1665 10.1362 9.1665 8.43148C9.13193 7.83663 9.34567 7.25408 9.75675 6.82273C10.3938 6.29886 11.1917 6.01019 12.0165 6.00523C14.139 5.95273 15.1178 6.67273 15.918 7.76773L17.1293 6.88273C15.9749 5.22505 14.0179 4.31674 12.0068 4.50523C10.7933 4.51298 9.62264 4.95489 8.70675 5.75098C8.00511 6.4627 7.6289 7.4328 7.66725 8.43148C7.60045 9.52967 8.08885 10.5882 8.96775 11.25H3V12.75H13.239C14.7143 13.1775 15.5963 13.734 15.6188 15.2685C15.6681 15.9314 15.433 16.584 14.9722 17.0632C14.1786 17.6888 13.1926 18.0199 12.1823 18C10.6543 17.9557 9.23142 17.2115 8.3235 15.9817L7.17375 16.9447C8.35414 18.5178 10.1927 19.4602 12.159 19.5H12.234C13.6191 19.5159 14.9634 19.0315 16.02 18.1357C16.7783 17.3711 17.1775 16.3213 17.1188 15.246C17.1467 14.3364 16.8398 13.4482 16.2562 12.75H21V11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextStrikethrough.vue"]]);
